module.exports = __webpack_public_path__ + "000ca63e8876340812fc2c7547d43d0a.svg";